/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import LoaderIcon from '@material-ui/icons/MoreHoriz';
import {translate} from '@ion/core/src/locale/locale';
import ProgressIndicator from '@ion/dls/src/components/progressIndicator/ProgressIndicator';
import Tooltip from '../components/tooltip/Tooltip';
import {PAGE_SIZE} from './utils/AssetTreeLoader';
import styles from './AssetLoader.module.scss';

interface AssetLoaderProps {
  isLoading: boolean,
  remaining: number,
  group: string,
  classes?: object,
  treeIndex?: any;
}

// utility which determines the tooltip title based on the state of the loader ...
const getTitle = (group: string, remaining: number) => {
  if (remaining) {
    const isLast = PAGE_SIZE >= remaining;
    return translate(`tracking:assetLoader.load.${isLast ? 'last' : 'next'}`, {
      size : isLast ? remaining : PAGE_SIZE,
      remaining,
      group
    });
  }
  return translate('tracking:assetLoader.load.first', {group});
};

/**
 * Defines the Asset Loader component which displays either the loader
 * Icon or Loading Progress indicator dependeing on the state of the
 * Loaders Group.
 */
const AssetLoader = ({isLoading, remaining, group, treeIndex}: AssetLoaderProps) => {
  if (!isLoading) {
    return (
      <div className={styles.container}>
        <div className={styles.hrule} />
        <Tooltip title={getTitle(group, remaining)}
          enterDelay={400} leaveDelay={50} placement='left'>
          <LoaderIcon style={{marginTop: 4, marginLeft: 16}} />
        </Tooltip>
      </div>
    );
  }
  return (
    <div className={styles.container}>
      <div className={styles['loader-hrule']} />
      <div style={{display: 'inline-block', padding: 0, marginTop: 2, marginLeft: 16}}>
        <ProgressIndicator color={'#656565'} size={6} />
      </div>
    </div>
  );
};
export default React.memo(AssetLoader);
